import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import styles from './styles.css';
/*
const DESCRIPTIONS = {
  Solution: 'Perception of your solution',
  'Sales Team': 'Perception of your sales performance',
  Company: 'Perception of your company and company\'s reputation',
};
*/
class PerformanceRenderer extends Component {
  renderDriver(driver) {
    let cls = 'label-warning';
    const hasDescription = driver && driver.description.length && driver.description.length > 0;

    if (driver.is_positive) {
      cls = 'label-success';
    } else if (driver.is_negative) {
      cls = 'label-danger';
    }
    const comp = (
      <span className={styles.tag} key={driver.driver_name}>
        <span className={`label label-default ${styles.label}`}>{driver.driver_name}</span>
        <span className={`label ${cls} ${styles.label}`}>{driver.performance}</span>
      </span>
    );
    if (hasDescription) {
      const popover = (
        <Tooltip id={`driver-${driver.driver_name}`}>
          <span>{driver.description}</span>
        </Tooltip>
      );
      return (
        <OverlayTrigger key={driver.driver_name} trigger="hover" placement="top" overlay={popover}>
          {comp}
        </OverlayTrigger>
      );
    }
    return comp;
  }

  render() {
    const { value } = this.props;
    if (!value) {
      return null;
    }
    return (
      <div className={styles.tags}>
        {value.map(driver => this.renderDriver(driver))}
      </div>
    );
  }
}

PerformanceRenderer.propTypes = {
  value: PropTypes.arrayOf(PropTypes.shape({
    driver_name: PropTypes.string,
    performance: PropTypes.string,
    description: PropTypes.string,
    is_positive: PropTypes.bool,
    is_negative: PropTypes.bool,
  })),
};
PerformanceRenderer.defaultProps = {
  value: null,
};

export default PerformanceRenderer;
